import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  "data-bs-backdrop": "static",
  "data-bs-keyboard": "false",
  id: "newAgencyModal",
  ref: "newAgencyModalRef",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_3 = { class: "modal-content rounded" }
const _hoisted_4 = /*#__PURE__*/_createStaticVNode("<div class=\"modal-header pt-8 pb-5 px-10\"><h5 class=\"modal-title fs-2 fw-bold\"><span class=\"me-2\"><i class=\"isax-setting-2 text-white fs-4\"></i></span>Configurar citas </h5><span data-bs-dismiss=\"modal\" class=\"pointer\"><i class=\"isax-close-circle text-white fs-2x pointer\"></i></span></div>", 1)
const _hoisted_5 = { class: "modal-body scroll-y pt-5 pb-10 px-10" }
const _hoisted_6 = /*#__PURE__*/_createStaticVNode("<ul class=\"nav nav-tabs nav-line-tabs nav-line-tabs-2x mb-5 fs-base\"><li class=\"nav-item\"><a class=\"nav-link active\" data-bs-toggle=\"tab\" data-toggle=\"tab\" href=\"#avaluo\">Avalúo</a></li><li class=\"nav-item\"><a class=\"nav-link\" data-bs-toggle=\"tab\" data-toggle=\"tab\" href=\"#venta\">Venta</a></li></ul>", 1)
const _hoisted_7 = {
  class: "tab-content mt-5",
  id: "myTabContent"
}
const _hoisted_8 = {
  class: "tab-pane fade show active",
  id: "avaluo",
  role: "tabpanel",
  "aria-labelledby": "avaluo"
}
const _hoisted_9 = {
  class: "tab-pane fade",
  id: "venta",
  role: "tabpanel",
  "aria-labelledby": "venta"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FormAvalue = _resolveComponent("FormAvalue")!
  const _component_FormSale = _resolveComponent("FormSale")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createVNode(_component_FormAvalue, {
                onCloseModal: _ctx.closeModal,
                change: _ctx.change
              }, null, 8, ["onCloseModal", "change"])
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createVNode(_component_FormSale, {
                onCloseModal: _ctx.closeModal,
                change: _ctx.change
              }, null, 8, ["onCloseModal", "change"])
            ])
          ])
        ])
      ])
    ])
  ], 512))
}